interface IRepoBaseInfo {
    repositoryId: string;
    repositoryName: string;
}

export enum IScope {
    public = 'public',
    limit = 'limited',
    private = 'private',
}

interface IRepoPermission {
    isAdmin: boolean;
    isMember: boolean;
    isReader: boolean;
    scope: IScope;
}

export interface IRepository {
    [key: string]: any;
    getRepoBaseInfo: () => IRepoBaseInfo;
    getRepoPermission: () => IRepoPermission;
}
